import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from '../Modal'
import { deleteProject } from '../../Accounts/API'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import SVGWrapper from '../../SVGWrapper'
import TrashIcon from '../../../../img/icon-trash.svg'

const ProjectDelete = ({ name, uuid, setDialog }) => {
    const onDelete = async () => {
        await deleteProject(uuid)
        setDialog('projectLoad')
    }

    return (
        <Modal>
            <header>
                <h2 className="title">Delete {name}?</h2>
            </header>
            <div className="space-between">
                <button
                    type="button"
                    onClick={() => setDialog('projectLoad', { selected: uuid })}
                    className="button is-neutral"
                >
                    Cancel
                </button>
                <button type="button" style={{ marginLeft: '50px' }} onClick={onDelete} className="button is-danger">
                    <SVGWrapper title="Trash Icon" fill="white">
                        <TrashIcon width={12} height={12} />
                    </SVGWrapper>{' '}
                    &nbsp; Delete
                </button>
            </div>
        </Modal>
    )
}

ProjectDelete.propTypes = {
    // parent
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string,
    // redux actions
    setDialog: PropTypes.func.isRequired
}

ProjectDelete.defaultProps = {
    // parent
    name: ''
}

export default connect(null, dispatch => ({
    setDialog: (dialog, modalProps) => dispatch(setDialogConnect(dialog, modalProps))
}))(ProjectDelete)
